const usertoken = {
    getlist: 'usertoken/getlist',
}
export default usertoken